import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Image, Flex, Text } from "@chakra-ui/react";
import icon from "../Assets/Images/icon.png";
import { AccountArea } from "../Components/Structure/accountArea";

export const Login = () => {
  const navigate = useNavigate();

  return (
    <Container maxW="sm" pt="10vh">
      <Flex
        borderRadius="20px"
        border="1px solid #e1e1e1"
        flexDirection="column"
        alignItems="flex-start"
        p="20px"
      >
        <Image
          borderRadius="10px"
          src={icon}
          alt="Proximy"
          h="50px"
          objectFit="contain"
        />
        <Text
          pt="10px"
          className="font-gilroy-bold"
          fontSize="30px"
          textAlign="start"
        >
          Let's Hangout
        </Text>
        <Text fontWeight="600" fontSize="14px" color="gray.600" pb="10px">
          Sign up or sign in
        </Text>
        <AccountArea isOpen onSignupComplete={() => navigate("/")} />
      </Flex>
    </Container>
  );
};
